
import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import ReactFlow, {
  Background,
  Controls,
  MarkerType,
} from "reactflow";
import Select from "react-select";
import "reactflow/dist/style.css";
import { apiFetch } from "../apiFetch";

const ColumnRelationDesignerScreen= ()  => {
  const navigate = useNavigate();

  const { state } = useLocation();

  const { configName } = useParams();

  const [customColumns, setCustomColumns] = useState([]);

  const [selectedColumn, setSelectedColumn] = useState(null);

  const [availableColumns, setAvailableColumns] = useState([]);

  const [dependencyColumns, setDependencyColumns] = useState([]);

  const [existingRelations, setExistingRelations] = useState([]);

  const [graphRelationData, setGraphRelationData] = useState([]);

  const [selectedRelation, setSelectedRelation] = useState({});

  const [propagationImpact, setPropagationImpact] = useState("HIGH");

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  const [ruleLogic, setRuleLogic] = useState("");
  
  const [deletingId, setDeletingId] = useState(null);

  const [editingRelationId, setEditingRelationId] = useState(null);

  const [runs, setRuns] = useState([]);

  const [selectedRun, setSelectedRun] = useState(null);

  /*************************************************
      FETCH RUNS
  /* =========================================== */
    // useEffect(() => {
    //   fetch(process.env.REACT_APP_BACKEND_URL + "dashboard/last-compare")
    //     .then((res) => res.json())
    //     .then((res) => {
    //       const sorted = res.sort(
    //         (a, b) => new Date(b.created_at) - new Date(a.created_at)
    //       );
    //       setRuns(sorted);
    //       setSelectedRun(sorted[0]);
    //     })
    //     .catch(setError);
    // }, []);

     useEffect(() => {
            apiFetch( "file-mapping-config")
              .then((res) => res.json())
              .then((res) => {
                const sorted = res.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
            setRuns(sorted);
            setSelectedRun(sorted[0]);
              })
              .catch((err) => console.error(err));
        }, []);
      

  /*************************************************
   * FETCH COLUMNS
   *************************************************/

  useEffect(() => {
    setLoading(true);

    apiFetch( "file-mapping-config/get-custom-column",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",
        },
 
        body: JSON.stringify({
          configId: selectedRun?.id
        }),
      }
    )
      .then((res) => res.json())

      .then((res) => {
        setCustomColumns(res || []);

        setAvailableColumns(res || []);
      })

      .catch(setError)

      .finally(() => setLoading(false));
  }, [selectedRun]);

  /*************************************************
   * FETCH RELATIONS
   *************************************************/

  useEffect(() => {
    fetchRelations();
  }, [selectedRun]);

  const fetchRelations = async () => {
    try {
      const res = await apiFetch(
        `file-column-mapping/relation/${selectedRun.id}`
      );

      const data = await res.json();

      setExistingRelations(data || []);

      generateGraph(data || []);
    } catch (err) {
      console.error(err);
    }
  };

  /*************************************************
   * HANDLE SELECT COLUMN
   *************************************************/

  const handleSelect = (id) => {
    const selected =
      customColumns.find(
        (c) => c.id == id
      );

    setSelectedColumn(selected);
    setSelectedRelation(null);
    setEditingRelationId(null);


    setDependencyColumns([]);

    const filtered =
      customColumns.filter(
        (c) => c.id != id
      );

    setAvailableColumns(filtered);
  };

  /*************************************************
   * ADD DEPENDENCY
   *************************************************/

  const handleAddDependency = (id) => {
    const column =
      availableColumns.find(
        (c) => c.id == id
      );

    if (
      !column ||
      dependencyColumns.some(
        (d) => d.id == column.id
      )
    ) {
      return;
    }

    setDependencyColumns((prev) => [
      ...prev,
      column,
    ]);

    setAvailableColumns((prev) =>
      prev.filter(
        (c) => c.id != column.id
      )
    );
  };

  /*************************************************
   * REMOVE DEPENDENCY
   *************************************************/

  const removeDependency = (column) => {
    setDependencyColumns((prev) =>
      prev.filter(
        (c) => c.id != column.id
      )
    );

    setAvailableColumns((prev) => [
      ...prev,
      column,
    ]);
  };

  /*************************************************
   * SAVE RELATION
   *************************************************/

  const handleSaveDependancy = async () => {
  if (!selectedColumn) {
    return;
  }

  // =========================
  // Payload
  // =========================

    const payload = {
    
      configId: selectedRun.id,

      columnId: selectedColumn.id,

      columnName:
        selectedColumn.source_column,

      relationType:
        selectedRelation?.relationType ||
        "FORMULA_DEPENDENCY",

      ruleLogic:
        ruleLogic ||
        `${selectedColumn.source_column} depends on ${dependencyColumns
          .map((c) => c.source_column)
          .join(", ")}`,

      propagationImpact:
        propagationImpact || "HIGH",

      description: `${selectedColumn.source_column} dependency configuration`,

      dependencies:
        dependencyColumns.map(
          (column, index) => ({
            dependencyColumnId:
              column.id,

            dependencyColumnName:
              column.source_column,

            executionOrder:
              index + 1,

            isRequired: true,
          })
        ),
    };

    try {
      let response;

      // =========================
      // UPDATE
      // =========================

      if (editingRelationId) {
        response = await apiFetch(
          `file-column-mapping/relation/${editingRelationId}`,
          {
            method: "PUT",

            headers: {
              "Content-Type":
                "application/json",
            },

            body: JSON.stringify(
              payload
            ),
          }
        );
      }

      // =========================
      // CREATE
      // =========================

      else {
        response = await apiFetch(
          `file-column-mapping/relation`,
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",
            },

            body: JSON.stringify(
              payload
            ),
          }
        );
      }

      const savedRelation =
        await response.json();

      console.log(
        "Saved Relation",
        savedRelation
      );

      // =========================
      // Refresh Relations
      // =========================

      await fetchRelations();

      // =========================
      // Reset Form
      // =========================

      setEditingRelationId(null);

      setSelectedRelation(null);

      setSelectedColumn(null);

      setDependencyColumns([]);

      setRuleLogic("");

      setPropagationImpact("HIGH");
    } catch (err) {
      console.error(err);
    }
  };

  /*************************************************
   * EDIT RELATION
   *************************************************/
  const handleEditRelation = (relation) => {
    setEditingRelationId(
      relation.id
    );

    setSelectedRelation(relation);

    setRuleLogic(
      relation.ruleLogic || ""
    );

    setPropagationImpact(
      relation.propagationImpact ||
        "HIGH"
    );

    // Target Column
    const selected =
      customColumns.find(
        (col) =>
          col.id == relation.columnId
      );

    setSelectedColumn(selected);

    // Dependencies
    const deps =
      relation.dependencies
        .map((dep) =>
          customColumns.find(
            (col) =>
              col.id ==
              dep.dependencyColumnId
          )
        )
        .filter(Boolean);

    setDependencyColumns(deps);

    // Available Columns
    const usedIds = [
      relation.columnId,
      ...relation.dependencies.map(
        (d) =>
          d.dependencyColumnId
      ),
    ];

    setAvailableColumns(
      customColumns.filter(
        (col) =>
          !usedIds.includes(col.id)
      )
    );
  };
  

  /*************************************************
   * GENERATE GRAPH
   *************************************************/

  const generateGraph = (
    relations
  ) => {
    const graphData = [];

    relations.forEach(
      (relation) => {
        relation.dependencies.forEach(
          (dep) => {
            graphData.push({
              parent:
                dep.dependencyColumnName,

              child:
                relation.columnName,
            });
          }
        );
      }
    );

    setGraphRelationData(
      graphData
    );
  };

  const handleImpactButtonClick =(value)=>{

    setPropagationImpact(value)
  }

  const handleDeleteRelation = async (
  relationId
) => {
  try {
    await apiFetch(
      `file-column-mapping/relation/${relationId}`,
      {
        method: "DELETE",
      }
    );

    const updated =
      existingRelations.filter(
        (r) => r.id !== relationId
      );

    setExistingRelations(updated);

    generateGraph(updated);

    setDeletingId(null);

    if (
      selectedRelation?.id ===
      relationId
    ) {
      setSelectedRelation(null);
      setSelectedColumn(null);
      setDependencyColumns([]);
    }
  } catch (err) {
    console.error(err);
  }
};
/**=========================================
      DROPDOWN GROUPING
/* ========================================= */
  const groupedOptions = useMemo(() => {
    // return Object.values(
    //   runs.reduce((acc, run) => {
    //     if (!acc[run.configName]) {
    //       acc[run.configName] = {
    //         label: run.configName,
    //         options: [],
    //       };
    //     }
    //     acc[run.configName].options.push({
    //       value: run.id,
    //       label: run.configName,
    //       fullData: run,
    //     });

    //     return acc;
    //   }, {})
    // );
   return runs
  }, []);


 

  return (

      <div className="bg-gray-50 min-h-screen p-6 font-display text-slate-900 min-h-screen flex flex-col">
      {/* MAIN */}
      <main className="flex-1 px-6 md:px-10 py-8 max-w-[1440px] mx-auto w-full">
        {/* HEADER */}
        <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm mb-6 flex items-center justify-between">
          <div>
            <div className="text-xs font-black tracking-[0.3em] text-slate-400 uppercase">
              Reconciliation
              Configuration
            </div>

            <h1 className="mt-2 text-2xl font-black text-slate-900">
              Column Relation
              Designer
            </h1>

            <p className="mt-2 text-slate-500">
              Configure dependency
              chains and mismatch
              propagation flow.
            </p>
          </div>


          
              {/* RIGHT */}
              <div className="flex flex-col items-stretch gap-4 min-w-[420px]">

                {/* SELECT */}
                {/* <Select
                  options={runs}
                  value={selectedRun?.configName
                   
                  }
                  onChange={(s) => setSelectedRun(s)}
                  placeholder="Search compare runs..."
                /> */}

                <select
                    value={
                      selectedRun?.id ||
                      ""
                    }
                    onChange={(e) =>
                      setSelectedRun(
                        runs.find(r=>r.id==e.target.value)
                      )
                    }
                    className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-4"
                  >
                    <option value="">
                      Select Config
                    </option>

                    {runs.map(
                      (column) => (
                        <option
                          key={column.id}
                          value={column.id}>{
                            column.configName
                          }
                        </option>
                      )
                    )}
                  </select>
              </div>
          
        </div>

         
        {/* MAIN GRID */}

        <div className="grid grid-cols-12 gap-6 items-start">

          {/* LEFT PANEL */}

          <div className="col-span-12 xl:col-span-6">
            <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">

              <div className="px-6 py-5 border-b border-slate-100">
                <h2 className="text-xl font-black text-slate-900">
                  Relation
                  Configuration
                </h2>
              </div>

              <div className="p-6 space-y-6">

                {/* TARGET COLUMN */}

                <div>
                  <label className="block mb-2 text-sm font-bold text-slate-700">
                    Target Column
                  </label>

                  <select
                    value={
                      selectedColumn?.id ||
                      ""
                    }
                    onChange={(e) =>
                      handleSelect(
                        e.target.value
                      )
                    }
                    className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-4"
                  >
                    <option value="">
                      Select Column
                    </option>

                    {customColumns.map(
                      (column) => (
                        <option
                          key={
                            column.id
                          }
                          value={
                            column.id
                          }
                        >
                          {
                            column.source_column
                          }
                        </option>
                      )
                    )}
                  </select>
                </div>

                {/* DEPENDENCY */}

                <div>
                  <label className="block mb-2 text-sm font-bold text-slate-700">
                    Dependency
                    Columns
                  </label>

                  <select
                    onChange={(e) =>
                      handleAddDependency(
                        e.target
                          .value
                      )
                    }
                    className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-4"
                  >
                    <option value="">
                      Select Dependency
                    </option>

                    {availableColumns.map(
                      (column) => (
                        <option
                          key={
                            column.id
                          }
                          value={
                            column.id
                          }
                        >
                          {
                            column.source_column
                          }
                        </option>
                      )
                    )}
                  </select>

                  <div className="mt-4 flex flex-wrap gap-2">
                    {dependencyColumns.map(
                      (column) => (
                        <div
                          key={
                            column.id
                          }
                          className="flex items-center gap-2 bg-blue-50 border border-blue-200 text-blue-700 px-3 py-2 rounded-xl text-sm font-semibold"
                        >
                          {
                            column.source_column
                          }

                          <button
                            onClick={() =>
                              removeDependency(
                                column
                              )
                            }
                          >
                            ✕
                          </button>
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* PREVIEW */}

                <div className="rounded-2xl bg-slate-50 border border-slate-200 p-5">
                  <div className="text-sm font-bold text-slate-700 mb-3">
                    Dependency
                    Preview
                  </div>

                  {selectedColumn ? (
                    <div className="space-y-3">

                      <div className="text-sm text-slate-600">
                        <span className="font-bold text-slate-900">
                          {
                            selectedColumn.source_column
                          }
                        </span>{" "}
                        depends on:
                      </div>

                      <div className="flex flex-wrap gap-2">
                        {dependencyColumns.length >
                        0 ? (
                          dependencyColumns.map(
                            (
                              dep
                            ) => (
                              <span
                                key={
                                  dep.id
                                }
                                className="px-3 py-1 rounded-full bg-white border border-slate-300 text-sm"
                              >
                                {
                                  dep.source_column
                                }
                              </span>
                            )
                          )
                        ) : (
                          <span className="text-slate-400 text-sm">
                            No
                            dependencies
                            selected
                          </span>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="text-slate-400 text-sm">
                      Select target
                      column
                    </div>
                  )}
                </div>

                {/* RELATION TYPE */}

                <div>
                  <label className="block mb-2 text-sm font-bold text-slate-700">
                    Relation Type
                  </label>

                  <select
                    className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-4"
                    value={
                      selectedRelation?.relationType ||
                      ""
                    }
                   onChange={(e) =>{
                       setSelectedRelation({
                        ...selectedRelation,
                        'relationType':e.target.value
                       });
                    }}
                  >
                    <option>
                      FORMULA_DEPENDENCY
                    </option>

                    <option>
                      LOOKUP_DEPENDENCY
                    </option>

                    <option>
                      REFERENCE_DEPENDENCY
                    </option>

                    <option>
                      CHAIN_DEPENDENCY
                    </option>
                  </select>
                </div>

                {/* RULE */}

                <div>
                  <label className="block mb-2 text-sm font-bold text-slate-700">
                    Rule Logic
                  </label>

                  <textarea
                    rows={5}
                    value={ruleLogic}
                    onChange={(e) =>
                      setRuleLogic(e.target.value)
                    }
                    className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-4 font-mono text-sm"
                  />
                </div>
                {/* Severity */}
                 <div>
                   <label className="block text-sm font-bold text-slate-700 mb-3">
                    Propagation Impact
                  </label>

                  <div className="grid grid-cols-2 gap-3">
                    <ImpactButton label="LOW"  propagationImpact = {propagationImpact}  handler ={handleImpactButtonClick} />
                    <ImpactButton label="MEDIUM"   propagationImpact = {propagationImpact} handler={handleImpactButtonClick} />
                    <ImpactButton label="HIGH"   propagationImpact = {propagationImpact} handler={handleImpactButtonClick}/>
                    <ImpactButton label="CRITICAL"  propagationImpact = {propagationImpact} handler={handleImpactButtonClick}/>
                 </div>
               </div>
               <div className="grid grid-cols-1">
                  <button
                    className="bg-primary px-8 py-4 rounded-2xl  hover:bg-primary/90 text-white font-bold shadow-lg"
                    onClick={handleSaveDependancy}
                  >
                    {editingRelationId
                      ? "Update Dependency Mapping"
                      : "Save Dependency Mapping"}
                </button>
               </div>
                
              </div>
            </div>
          </div>

          {/* CENTER GRAPH */}

          {/* <div className="col-span-12 xl:col-span-5">
            <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">

              <div className="px-6 py-5 border-b border-slate-100">
                <h2 className="text-xl font-black text-slate-900">
                  Dependency Flow
                </h2>
              </div>

              <div className="h-[850px] bg-slate-50">

                {graphRelationData.length >
                  0 && (
                  <TreeDependencyFlow
                    relationData={
                      graphRelationData
                    }
                  />
                )}

              </div>
            </div>
          </div> */}

          {/* RIGHT PANEL */}

          <div className="col-span-12 xl:col-span-6">
            <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">

              <div className="px-6 py-5 border-b border-slate-100">
                <h2 className="text-xl font-black text-slate-900">
                  Existing
                  Relations
                </h2>
              </div>

             <div className="p-5 space-y-3">
                {existingRelations?.map((relation) => (
                  <div
                    key={relation?.id}
                    className={`rounded-2xl border p-4 transition-all ${
                      selectedRelation?.id === relation?.id
                        ? "border-blue-300 bg-blue-50"
                        : "border-slate-200 bg-slate-50"
                    }`}
                  >
                    {/* Top */}
                    <div className="flex items-start justify-between gap-4">
                      <div
                        className="flex-1 cursor-pointer"
                        onClick={() =>
                          handleEditRelation(relation)
                        }
                      >
                        <div className="font-bold text-slate-800 text-sm">
                          {relation.columnName}
                        </div>

                        <div className="mt-2 flex flex-wrap gap-2">
                          {relation.dependencies.map((dep) => (
                            <span
                              key={dep.id}
                              className="px-2 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold"
                            >
                              {dep.dependencyColumnName}
                            </span>
                          ))}
                        </div>
                      </div>

                      {/* Actions */}
                     
                     <div className="flex items-center gap-2">
                        <button
                          onClick={() =>
                            handleEditRelation(relation)
                          }
                          className="px-3 py-2 rounded-xl bg-slate-200 hover:bg-slate-300 text-xs font-bold text-slate-700"
                        >
                          Edit
                        </button>

                        {deletingId === relation.id ? (
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleDeleteRelation(
                                  relation.id
                                )
                              }
                              className="px-2 py-1 rounded-lg bg-red-600 hover:bg-red-700 text-white text-xs font-bold"
                            >
                              Confirm
                            </button>

                            <button
                              onClick={() =>
                                setDeletingId(null)
                              }
                              className="text-xs text-slate-500 hover:text-slate-700"
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() =>
                              setDeletingId(relation.id)
                            }
                            className="w-8 h-8 rounded-lg flex items-center justify-center text-red-500 hover:bg-red-50 hover:text-red-700 transition-all"
                          >
                            🗑
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </main>
    </div>
  );

}

/*************************************************
 * TREE FLOW
 *************************************************/

function TreeDependencyFlow({
  relationData,
}) {
  const { nodes, edges } =
    useMemo(() => {

      const levels = {};

      function assignLevel(
        node,
        level
      ) {
        if (
          levels[node] !==
            undefined &&
          levels[node] >= level
        ) {
          return;
        }

        levels[node] = level;

        relationData
          .filter(
            (r) =>
              r.parent === node
          )
          .forEach((r) => {
            assignLevel(
              r.child,
              level + 1
            );
          });
      }

      const children = new Set(
        relationData.map(
          (r) => r.child
        )
      );

      const parents = new Set(
        relationData.map(
          (r) => r.parent
        )
      );

      const rootNode =
        Array.from(parents).find(
          (p) =>
            !children.has(p)
        );

      assignLevel(rootNode, 0);

      const groupedLevels = {};

      Object.entries(levels).forEach(
        ([node, level]) => {
          if (
            !groupedLevels[level]
          ) {
            groupedLevels[
              level
            ] = [];
          }

          groupedLevels[
            level
          ].push(node);
        }
      );

      const generatedNodes = [];

      Object.entries(
        groupedLevels
      ).forEach(
        ([level, nodesAtLevel]) => {
          nodesAtLevel.forEach(
            (
              nodeName,
              index
            ) => {
              generatedNodes.push({
                id: nodeName,

                data: {
                  label:
                    nodeName,
                },

                position: {
                  x:
                    index *
                      260 +
                    100,

                  y:
                    Number(
                      level
                    ) *
                      180 +
                    80,
                },

                style: {
                  width: 220,

                  padding: 18,

                  borderRadius: 20,

                  border:
                    "2px solid #cbd5e1",

                  background:
                    "white",

                  fontWeight: 700,

                  fontSize: 15,

                  boxShadow:
                    "0 8px 24px rgba(0,0,0,0.08)",
                },
              });
            }
          );
        }
      );

      const generatedEdges =
        relationData.map(
          (
            relation,
            index
          ) => ({
            id: `edge-${index}`,

            source:
              relation.parent,

            target:
              relation.child,

            type:
              "smoothstep",

            animated: true,

            markerEnd: {
              type: MarkerType.ArrowClosed,
            },

            style: {
              strokeWidth: 3,
            },
          })
        );

      return {
        nodes: generatedNodes,

        edges: generatedEdges,
      };
    }, [relationData]);

  return (
    <div className="w-full h-full bg-slate-50">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView
      >
        <Background />
        <Controls />
      </ReactFlow>
    </div>
  );

}

/**
 * IMPACT BUTTON
 */
function ImpactButton({
  label,
  propagationImpact,
  handler
}) {
  const active =
    propagationImpact === label;

  return (
    <button
      onClick={() => handler(label)}
      className={`rounded-2xl py-3 font-bold transition-all border
        ${
          active
            ? "bg-blue-700 text-white border-blue-700 shadow-lg shadow-blue-200 scale-[1.02]"
            : "bg-slate-100 text-slate-600 border-slate-200 hover:bg-slate-200"
        }
      `}
    >
      {label}
    </button>
  );
}

export default  ColumnRelationDesignerScreen